import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import useLang from '../hooks/useLang'
import './Home.css'

// Импорты изображений
import logoQaraa from '../images/logo-qaraa.webp'
import humanImage from '../images/human.webp'
import cardImage from '../images/card.webp'
import cardImage2 from '../images/card2.webp'
import qaraaCrmLogo from '../images/qaraaxqaraa-crm.webp'
import crmIcon from '../images/crm.webp'
import supportIcon from '../images/support.webp'
import securatiyIcon from '../images/securatiy.webp'
import oneclickIcon from '../images/oneclick.webp'
import oplataIcon from '../images/oplata.webp'
import trackingIcon from '../images/tracking.webp'
import bonuscardIcon from '../images/bonuscard.webp'
import cashIcon from '../images/cash.webp'

export default function Home() {
  const navigate = useNavigate()
  const { lang, changeLang, t, languages } = useLang()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [langDropdownOpen, setLangDropdownOpen] = useState(false)
  const langRef = useRef(null)
  const [currentCardIndex, setCurrentCardIndex] = useState(0)
  const [isAutoPlaying, setIsAutoPlaying] = useState(true)
  const [touchStart, setTouchStart] = useState(0)
  const [touchEnd, setTouchEnd] = useState(0)
  const cardImages = [cardImage, cardImage2]
  const stepIcons = [crmIcon, supportIcon, securatiyIcon, oneclickIcon, oplataIcon, trackingIcon, bonuscardIcon, cashIcon]

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) {
        setLangDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
    window.scrollTo(0, 0)
    document.title = 'qaraa.asia'
  }, [])

  // Автоматическая смена карточек (останавливается при ручном взаимодействии)
  useEffect(() => {
    if (!isAutoPlaying) return

    const interval = setInterval(() => {
      setCurrentCardIndex((prevIndex) => (prevIndex + 1) % cardImages.length)
    }, 5000) // Меняем каждые 5 секунд

    return () => clearInterval(interval)
  }, [isAutoPlaying, cardImages.length])

  const handleManualCardChange = (newIndex) => {
    setCurrentCardIndex(newIndex)
    setIsAutoPlaying(false) // Останавливаем автопрокрутку

    // Возобновляем автопрокрутку через 10 секунд бездействия
    setTimeout(() => {
      setIsAutoPlaying(true)
    }, 10000)
  }

  const handlePrevCard = () => {
    const newIndex = (currentCardIndex - 1 + cardImages.length) % cardImages.length
    handleManualCardChange(newIndex)
  }

  const handleNextCard = () => {
    const newIndex = (currentCardIndex + 1) % cardImages.length
    handleManualCardChange(newIndex)
  }

  // Обработка свайпа для мобильных
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX)
  }

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return

    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > 50
    const isRightSwipe = distance < -50

    if (isLeftSwipe) {
      handleNextCard()
    }
    if (isRightSwipe) {
      handlePrevCard()
    }

    setTouchStart(0)
    setTouchEnd(0)
  }

  return (
    <div style={{ minHeight: '100vh', background: '#FFFFFF' }}>
      {/* Fixed Header */}
      <header style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: 'rgba(255, 255, 255, 0.72)',
        backdropFilter: 'saturate(180%) blur(20px)',
        WebkitBackdropFilter: 'saturate(180%) blur(20px)',
        transition: 'all 0.3s ease'
      }}>
        <div className="home-header-container" style={{
          maxWidth: '1440px',
          margin: '0 auto',
          padding: '20px 48px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div className="home-logo-container" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            cursor: 'pointer',
            transition: 'opacity 0.3s ease',
            opacity: 1
          }}
            onClick={() => navigate('/')}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            <img
              src={logoQaraa}
              alt="qaraa"
              className="home-logo"
              style={{
                height: '42px',
                width: 'auto',
                transition: 'transform 0.3s ease'
              }}
            />
            <div>
              <div className="home-logo-title" style={{
                fontSize: '17px',
                fontWeight: '600',
                color: '#1C1C1E',
                lineHeight: '1.2'
              }}>
                <span className="logo-title-line1">qaraa.asia</span>
                <br className="mobile-break" />
                <span className="logo-title-line2 mobile-only-subtitle" style={{ fontSize: '12px', color: '#8E8E93', fontWeight: '500' }}>{t.logoSubtitle}</span>
              </div>
              <div className="home-logo-subtitle desktop-only-subtitle" style={{
                fontSize: '12px',
                color: '#8E8E93',
                marginTop: '4px'
              }}>
                {t.logoSubtitle}
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {/* Language Switcher */}
            <div ref={langRef} style={{ position: 'relative', marginRight: '6px' }}>
              <button
                onClick={() => setLangDropdownOpen(!langDropdownOpen)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 14px',
                  background: langDropdownOpen ? 'rgba(0,0,0,0.06)' : 'transparent',
                  border: 'none',
                  borderRadius: '100px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#1C1C1E',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
                }}
                onMouseEnter={(e) => { if (!langDropdownOpen) e.currentTarget.style.background = 'rgba(0,0,0,0.04)' }}
                onMouseLeave={(e) => { if (!langDropdownOpen) e.currentTarget.style.background = 'transparent' }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="2" y1="12" x2="22" y2="12"/>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                </svg>
                <span className="lang-text-label">{t.languageLabel}</span>
                <svg className="lang-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: langDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}>
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              {langDropdownOpen && (
                <div style={{
                  position: 'absolute',
                  top: 'calc(100% + 8px)',
                  right: 0,
                  background: '#FFFFFF',
                  borderRadius: '14px',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 0 1px rgba(0,0,0,0.08)',
                  padding: '6px',
                  minWidth: '160px',
                  zIndex: 200,
                  animation: 'fadeIn 0.15s ease'
                }}>
                  {languages.map((l) => (
                    <button
                      key={l.code}
                      onClick={() => { changeLang(l.code); setLangDropdownOpen(false) }}
                      style={{
                        display: 'block',
                        width: '100%',
                        padding: '10px 14px',
                        background: lang === l.code ? 'rgba(0,122,255,0.08)' : 'transparent',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '15px',
                        fontWeight: lang === l.code ? '600' : '500',
                        color: lang === l.code ? '#007AFF' : '#1C1C1E',
                        cursor: 'pointer',
                        textAlign: 'left',
                        transition: 'all 0.15s ease',
                        fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
                      }}
                      onMouseEnter={(e) => { if (lang !== l.code) e.currentTarget.style.background = 'rgba(0,0,0,0.04)' }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = lang === l.code ? 'rgba(0,122,255,0.08)' : 'transparent' }}
                    >
                      {l.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button
              onClick={() => navigate('/auth')}
              className="home-header-button-login"
              style={{
                padding: '10px 22px',
                background: 'transparent',
                border: 'none',
                borderRadius: '100px',
                fontSize: '15px',
                fontWeight: '600',
                color: '#000000',
                cursor: 'pointer',
                transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                position: 'relative',
                letterSpacing: '-0.3px',
                fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(0, 0, 0, 0.06)'
                e.target.style.transform = 'scale(1.02)'
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent'
                e.target.style.transform = 'scale(1)'
              }}
            >
              {t.login}
            </button>
            <button
              onClick={() => navigate('/auth?mode=register')}
              className="home-header-button-register"
              style={{
                padding: '10px 22px',
                background: '#FFFFFF',
                border: '1.5px solid #007AFF',
                borderRadius: '100px',
                fontSize: '15px',
                fontWeight: '600',
                color: '#007AFF',
                cursor: 'pointer',
                transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                letterSpacing: '-0.3px',
                fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#007AFF'
                e.target.style.color = '#FFFFFF'
                e.target.style.transform = 'scale(1.02)'
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#FFFFFF'
                e.target.style.color = '#007AFF'
                e.target.style.transform = 'scale(1)'
              }}
            >
              {t.register}
            </button>

            {/* Мобильное меню - три полоски */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="home-mobile-menu-button"
              style={{
                display: 'none',
                padding: '8px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                flexDirection: 'column',
                gap: '5px'
              }}
            >
              <span style={{
                width: '24px',
                height: '2px',
                background: '#000000',
                borderRadius: '2px',
                transition: 'all 0.3s',
                transform: mobileMenuOpen ? 'rotate(45deg) translateY(7px)' : 'none'
              }}></span>
              <span style={{
                width: '24px',
                height: '2px',
                background: '#000000',
                borderRadius: '2px',
                transition: 'all 0.3s',
                opacity: mobileMenuOpen ? 0 : 1
              }}></span>
              <span style={{
                width: '24px',
                height: '2px',
                background: '#000000',
                borderRadius: '2px',
                transition: 'all 0.3s',
                transform: mobileMenuOpen ? 'rotate(-45deg) translateY(-7px)' : 'none'
              }}></span>
            </button>
          </div>
        </div>
      </header>

      {/* Мобильное выпадающее меню */}
      {mobileMenuOpen && (
        <div
          className="home-mobile-menu"
          style={{
            position: 'fixed',
            top: '76px',
            left: 0,
            right: 0,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'saturate(180%) blur(20px)',
            WebkitBackdropFilter: 'saturate(180%) blur(20px)',
            borderBottom: 'none',
            padding: '16px 20px',
            zIndex: 99,
            display: 'none',
            flexDirection: 'column',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
          }}
        >
          <button
            onClick={() => {
              navigate('/auth')
              setMobileMenuOpen(false)
            }}
            style={{
              padding: '12px 20px',
              background: 'rgba(0, 0, 0, 0.06)',
              border: 'none',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: '600',
              color: '#000000',
              cursor: 'pointer',
              width: '100%',
              letterSpacing: '-0.3px',
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
              transition: 'all 0.2s ease'
            }}
          >
            {t.login}
          </button>
          <button
            onClick={() => {
              navigate('/auth?mode=register')
              setMobileMenuOpen(false)
            }}
            style={{
              padding: '12px 20px',
              background: 'linear-gradient(180deg, #007AFF 0%, #0051D5 100%)',
              border: 'none',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: '600',
              color: '#FFFFFF',
              cursor: 'pointer',
              width: '100%',
              letterSpacing: '-0.3px',
              boxShadow: '0 2px 8px rgba(0, 122, 255, 0.25)',
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
              transition: 'all 0.2s ease'
            }}
          >
            {t.register}
          </button>
        </div>
      )}

      {/* Hero Section */}
      <section className="home-hero-section" style={{
        paddingTop: '100px',
        paddingBottom: '100px',
        background: '#FFFFFF'
      }}>
        <div className="home-hero-container" style={{
          maxWidth: '1440px',
          margin: '0 auto',
          padding: '0 48px',
          display: 'grid',
          gridTemplateColumns: '1.3fr 1fr',
          gap: '80px',
          alignItems: 'center'
        }}>
          <div className="home-hero-title-content">
            <h1 className="home-hero-title" style={{
              fontSize: '80px',
              fontWeight: '700',
              lineHeight: '1.05',
              marginBottom: '0',
              color: '#1d1d1f',
              letterSpacing: '-0.015em'
              }}>
              <span dangerouslySetInnerHTML={{ __html: t.heroTitle }} />
            </h1>
          </div>

          <div className="home-human-container" style={{
            position: 'relative'
          }}>
            <img
              src={humanImage}
              className="home-human-image"
              alt="qaraa fashion"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
          </div>

          <div className="home-hero-description-content">
            <p style={{
              fontSize: '20px',
              color: '#6e6e73',
              lineHeight: '1.6',
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
              maxWidth: '520px',
              margin: '0'
            }}>{t.heroDescription}<span 
                onClick={() => navigate('/auth?mode=register')}
                className="highlight-wave" 
                style={{ 
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >{t.heroBonusLink}</span>{t.heroDescriptionEnd}</p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="home-stats-section" style={{
        padding: '120px 0',
        background: '#f5f5f7',
        borderRadius: '60px 60px 0 0',
        marginTop: '-40px',
        position: 'relative'
      }}>
        <div className="home-stats-section-container" style={{
          maxWidth: '1440px',
          margin: '0 auto',
          padding: '0 48px'
        }}>
          <h2 className="home-stats-section-title" style={{
            fontSize: '64px',
            fontWeight: '700',
            lineHeight: '1.05',
            marginBottom: '32px',
            color: '#1d1d1f',
            letterSpacing: '-0.015em',
            maxWidth: '900px'
          }}>
            {t.statsTitle}
          </h2>

          <p style={{
            fontSize: '21px',
            color: '#6e6e73',
            lineHeight: '1.47',
            marginBottom: '80px',
            maxWidth: '900px',
            fontWeight: '400'
          }}>
            {t.statsDescription}
          </p>

          <div className="home-steps-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '32px'
          }}>
            {t.steps.map((item, i) => (
              <div key={i} className="home-step-card" style={{
                background: '#FFFFFF',
                padding: '40px',
                borderRadius: '18px',
                position: 'relative',
                overflow: 'hidden',
                marginBottom: '0',
                border: '1px solid rgba(0, 0, 0, 0.04)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)'
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.08)'
                  e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.08)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = 'none'
                  e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.04)'
                }}>
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  opacity: '0.1',
                  transform: 'rotate(15deg)'
                }}>
                  <img
                    src={stepIcons[i]}
                    alt=""
                    style={{
                      width: '120px',
                      height: '120px',
                      objectFit: 'contain'
                    }}
                  />
                </div>
                <div style={{
                  marginBottom: '20px'
                }}>
                  <img
                    src={stepIcons[i]}
                    alt={item.title}
                    style={{
                      width: '64px',
                      height: '64px',
                      objectFit: 'contain'
                    }}
                  />
                </div>
                <div className="home-step-number" style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#999999',
                  marginBottom: '20px',
                  letterSpacing: '1px'
                }}>
                  {item.number}
                </div>
                <h3 className="home-step-title" style={{
                  fontSize: '24px',
                  fontWeight: '600',
                  color: '#1d1d1f',
                  marginBottom: '12px',
                  letterSpacing: '-0.01em'
                }}>
                  {item.title}
                </h3>
                <p className="home-step-description" style={{
                  fontSize: '17px',
                  color: '#6e6e73',
                  lineHeight: '1.47',
                  fontWeight: '400'
                }}>
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bonus Card Section */}
      <section className="home-benefits-section" style={{
        padding: '120px 0',
        background: '#FFFFFF',
        borderRadius: '60px 60px 0 0',
        marginTop: '-40px',
        position: 'relative'
      }}>
        <div className="home-benefits-container" style={{
          maxWidth: '1440px',
          margin: '0 auto',
          padding: '0 48px'
        }}>
          <h2 className="home-benefits-title" style={{
            fontSize: '64px',
            fontWeight: '700',
            lineHeight: '1.05',
            marginBottom: '80px',
            color: '#1d1d1f',
            letterSpacing: '-0.015em',
            textAlign: 'center'
          }}>
            {t.bonusTitle}
          </h2>

          <div className="home-card-grid" style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '80px',
            alignItems: 'center'
          }}>
            <div
              className="home-card-container"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              style={{
                position: 'relative',
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.1)'
              }}>
              <img
                src={cardImages[currentCardIndex]}
                className="home-card-image"
                alt="qaraa card"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  transition: 'opacity 0.5s ease'
                }}
              />

              <div className="home-card-overlay" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div className="home-card-number" style={{
                  fontSize: '17px',
                  fontWeight: '600',
                  color: '#000000',
                  letterSpacing: '2px',
                  fontFamily: 'monospace',
                  textAlign: 'right',
                  paddingRight: '10px',
                  marginTop: '3px'
                }}>
                  {t.cardNumber}
                </div>

                <div className="home-card-bonus-container" style={{
                  paddingLeft: '10px',
                  marginBottom: '-18px'
                }}>
                  <div className="home-card-bonus-label" style={{
                    fontSize: '12px',
                    color: '#000000',
                    opacity: 0.7,
                    marginBottom: '4px'
                  }}>
                  {t.bonusesLabel}
                  </div>
                  <div className="home-card-bonus-value" style={{
                    fontSize: '32px',
                    fontWeight: '700',
                    color: '#000000'
                  }}>
                  {t.bonusValue}
                  </div>
                </div>
              </div>

              {/* Кнопки навигации - скрыты на мобильных */}
              <button
                onClick={handlePrevCard}
                className="home-card-nav-btn home-card-nav-prev"
                style={{
                  position: 'absolute',
                  left: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'rgba(255, 255, 255, 0.92)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  border: '0.5px solid rgba(0, 0, 0, 0.04)',
                  borderRadius: '50%',
                  width: '44px',
                  height: '44px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  fontSize: '22px',
                  color: '#1d1d1f',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  zIndex: 10,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 1)'
                  e.target.style.transform = 'translateY(-50%) scale(1.05)'
                  e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.12)'
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.92)'
                  e.target.style.transform = 'translateY(-50%) scale(1)'
                  e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)'
                }}>
                ‹
              </button>
              <button
                onClick={handleNextCard}
                className="home-card-nav-btn home-card-nav-next"
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'rgba(255, 255, 255, 0.92)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  border: '0.5px solid rgba(0, 0, 0, 0.04)',
                  borderRadius: '50%',
                  width: '44px',
                  height: '44px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  fontSize: '22px',
                  color: '#1d1d1f',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  zIndex: 10,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 1)'
                  e.target.style.transform = 'translateY(-50%) scale(1.05)'
                  e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.12)'
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.92)'
                  e.target.style.transform = 'translateY(-50%) scale(1)'
                  e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)'
                }}>
                ›
              </button>

              {/* Индикаторы */}
              <div style={{
                position: 'absolute',
                bottom: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                gap: '8px',
                zIndex: 10
              }}>
                {cardImages.map((_, index) => (
                  <div
                    key={index}
                    onClick={() => handleManualCardChange(index)}
                    style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      background: currentCardIndex === index ? '#1d1d1f' : 'rgba(29, 29, 31, 0.3)',
                      cursor: 'pointer',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      transform: currentCardIndex === index ? 'scale(1.1)' : 'scale(1)'
                    }}
                  />
                ))}
              </div>
            </div>

            <div className="home-card-text-container">
              <p style={{
                fontSize: '21px',
                color: '#6e6e73',
                lineHeight: '1.47',
                marginBottom: '48px',
                fontWeight: '400'
              }}>
                {t.cardDescription}
              </p>
              <button
                onClick={() => navigate('/card-info')}
                style={{
                  padding: '12px 24px',
                  background: '#007AFF',
                  border: 'none',
                  borderRadius: '980px',
                  fontSize: '17px',
                  fontWeight: '600',
                  color: '#FFFFFF',
                  cursor: 'pointer',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 4px 12px rgba(0, 122, 255, 0.3)',
                  letterSpacing: '-0.01em',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)'
                  e.target.style.boxShadow = '0 8px 20px rgba(0, 122, 255, 0.4)'
                  e.target.style.background = '#0071e3'
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)'
                  e.target.style.boxShadow = '0 4px 12px rgba(0, 122, 255, 0.3)'
                  e.target.style.background = '#007AFF'
                }}>
                {t.cardDetailsButton}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        padding: '80px 24px 50px',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        color: '#1C1C1E',
        position: 'relative',
        borderRadius: '60px 60px 0 0',
        marginTop: '-40px'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '50px',
            marginBottom: '50px'
          }}>
            <div>
              <div style={{
                fontSize: '24px',
                fontWeight: '800',
                marginBottom: '16px',
                color: '#1C1C1E',
                letterSpacing: '-0.5px'
              }}>qaraa.asia</div>
              <div style={{
                marginBottom: '16px',
                display: 'flex',
                justifyContent: 'flex-start'
              }}>
                <img
                  src={qaraaCrmLogo}
                  alt="qaraa × qaraa.crm"
                  style={{
                    height: '100px',
                    width: 'auto'
                  }}
                />
              </div>
              <div style={{ fontSize: '15px', color: '#636366', fontWeight: '500' }}>{t.logoSubtitle}</div>
            </div>
            <div>
              <div style={{
                fontSize: '13px',
                fontWeight: '800',
                color: '#8E8E93',
                marginBottom: '20px',
                letterSpacing: '1.2px',
                textTransform: 'uppercase'
              }}>
                {t.footerNavigation}
              </div>
              {[{ name: t.footerAbout, path: '/about-us' }, { name: t.footerBonusCard, path: '/card-info' }, { name: t.footerVacancies, path: '/vacancies' }, { name: t.footerBusiness, path: '/business' }].map(l => (
                <div key={l.path} onClick={() => navigate(l.path)} style={{
                  fontSize: '15px',
                  marginBottom: '12px',
                  cursor: 'pointer',
                  color: '#1C1C1E',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#5856D6'
                    e.currentTarget.style.paddingLeft = '8px'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#1C1C1E'
                    e.currentTarget.style.paddingLeft = '0'
                  }}>
                  {l.name}
                </div>
              ))}
            </div>
            <div>
              <div style={{
                fontSize: '13px',
                fontWeight: '800',
                color: '#8E8E93',
                marginBottom: '20px',
                letterSpacing: '1.2px',
                textTransform: 'uppercase'
              }}>
                {t.footerSocial}
              </div>
              {[
                { name: 'Instagram', url: 'https://www.instagram.com/qaraa.kz?igsh=cWw3cmlsNmJ0ZHRi' },
                { name: 'TikTok', url: 'https://www.tiktok.com/@qaraa.kz?_r=1&_t=ZM-91EaJ8tj6Do' },
                { name: 'Telegram', url: 'https://t.me/qaraa_kz' },
                { name: 'WhatsApp', url: 'https://wa.me/77778307588' }
              ].map(s => (
                <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer" style={{
                  display: 'block',
                  fontSize: '15px',
                  color: '#1C1C1E',
                  fontWeight: '500',
                  textDecoration: 'none',
                  marginBottom: '12px',
                  transition: 'all 0.2s ease'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#5856D6'
                    e.currentTarget.style.paddingLeft = '8px'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#1C1C1E'
                    e.currentTarget.style.paddingLeft = '0'
                  }}>
                  {s.name}
                </a>
              ))}
            </div>
            <div>
              <div style={{
                fontSize: '13px',
                fontWeight: '800',
                color: '#8E8E93',
                marginBottom: '20px',
                letterSpacing: '1.2px',
                textTransform: 'uppercase'
              }}>
                {t.footerInfo}
              </div>
              <div style={{ fontSize: '15px', marginBottom: '12px', color: '#1C1C1E', fontWeight: '500' }}>+7 777 830 75 88</div>
              <div style={{ fontSize: '15px', color: '#636366', fontWeight: '500' }}>{t.footerCity}</div>
              <div style={{ fontSize: '15px', marginTop: '12px', color: '#636366', fontWeight: '500' }}>{t.footerAddress}</div>
            </div>
          </div>
          <div style={{
            marginTop: '80px',
            paddingTop: '40px',
            borderTop: '2px solid rgba(0, 0, 0, 0.06)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '20px',
            fontSize: '15px',
            color: '#8E8E93',
            fontWeight: '600'
          }}>
            <div>{t.footerRights}</div>
            <div style={{ display: 'flex', gap: '24px' }}>
              <span onClick={() => navigate('/privacy')} style={{
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#5856D6'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#8E8E93'
                }}>
                {t.footerPrivacy}
              </span>
              <span onClick={() => navigate('/terms')} style={{
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#5856D6'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#8E8E93'
                }}>
                {t.footerTerms}
              </span>
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile Styles */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        /* Скрываем перенос на десктопе */
        .mobile-break {
          display: none;
        }
        
        /* Desktop: группируем заголовок и описание по центру */
        .home-hero-container {
          align-items: stretch !important;
          row-gap: 24px !important;
        }
        
        .home-hero-title-content {
          grid-column: 1;
          grid-row: 1;
          align-self: end;
          margin-bottom: 0 !important;
        }

        .home-human-container {
          grid-column: 2;
          grid-row: 1 / span 2;
        }
        
        .home-hero-description-content {
          grid-column: 1;
          grid-row: 2;
          align-self: start;
          margin-top: 0 !important;
        }
        
        @media (max-width: 768px) {
          /* Показываем перенос на мобильных */
          .mobile-break {
            display: inline;
          }
          
          /* Mobile hero section: title → image → description */
          .home-hero-container {
            display: flex !important;
            flex-direction: column !important;
            gap: 32px !important;
            padding: 0 20px !important;
          }
          
          .home-hero-title-content {
            order: 1 !important;
          }
          
          .home-human-container {
            order: 2 !important;
          }
          
          .home-hero-description-content {
            order: 3 !important;
          }
          
          .home-hero-title {
            font-size: 48px !important;
            line-height: 1.08 !important;
            letter-spacing: -0.015em !important;
            margin-bottom: 0 !important;
          }
          
          .home-step-card {
            margin-bottom: 32px !important;
          }
          .home-step-card:last-child {
            margin-bottom: 40px !important;
          }
          
          /* Bonus Card Section - мобильная версия */
          .home-benefits-section {
            padding: 60px 0 !important;
          }
          
          .home-benefits-container {
            padding: 0 20px !important;
          }
          
          .home-benefits-title {
            font-size: 36px !important;
            margin-bottom: 40px !important;
          }
          
          .home-card-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
          
          .home-card-text-container {
            margin-bottom: 40px !important;
          }
          
          /* Скрываем стрелки навигации на мобильных */
          .home-card-nav-btn {
            display: none !important;
          }
          
          /* Header mobile: скрываем текст языка и шеврон, оставляем только иконку */
          .lang-text-label {
            display: none !important;
          }
          .lang-chevron {
            display: none !important;
          }
          .home-logo-subtitle.desktop-only-subtitle {
            display: none !important;
          }
          .mobile-only-subtitle {
            display: none !important;
          }
          .home-header-container {
            padding: 14px 16px !important;
          }
          .home-logo-container {
            gap: 10px !important;
          }
        }

        .highlight-wave {
          position: relative;
          color: #007AFF;
          display: inline-block;
          transition: all 0.2s ease;
        }
        
        .highlight-wave:hover {
          color: #0051D5;
          transform: scale(1.02);
        }
        
        .highlight-wave::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -2px;
          width: 100%;
          height: 8px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 10' preserveAspectRatio='none'%3E%3Cpath d='M1,7 Q25,2 50,6 T99,4' fill='none' stroke='%23007AFF' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          transition: transform 0.2s ease;
        }
        
        .highlight-wave:hover::after {
          transform: translateY(1px);
        }

        @media (max-width: 480px) {
          /* Footer - мобильная версия */
          footer {
            margin-top: -40px !important;
            padding: 50px 20px 35px !important;
            border-radius: 60px 60px 0 0 !important;
          }
          
          footer > div:first-child {
            padding: 0 !important;
            max-width: 100% !important;
            margin: 0 !important;
          }
          
          footer > div:first-child > div:first-child {
            grid-template-columns: 1fr !important;
            gap: 35px !important;
            margin-bottom: 35px !important;
            padding: 0 !important;
          }
          
          footer > div:first-child > div:first-child > div:first-child > div:first-child {
            font-size: 20px !important;
            margin-bottom: 10px !important;
          }
          
          footer > div:first-child > div:first-child > div:first-child > div:last-child {
            font-size: 14px !important;
          }
          
          footer > div:first-child > div:first-child > div > div:first-child {
            font-size: 11px !important;
            margin-bottom: 15px !important;
          }
          
          footer > div:first-child > div:first-child > div > div:not(:first-child),
          footer > div:first-child > div:first-child > div > a {
            font-size: 14px !important;
            margin-bottom: 10px !important;
          }
          
          footer > div:first-child > div:last-child {
            margin-top: 50px !important;
            padding-top: 30px !important;
            border-top: 2px solid rgba(0, 0, 0, 0.06) !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 16px !important;
            font-size: 13px !important;
          }
          
          footer > div:first-child > div:last-child > div:last-child {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 12px !important;
          }
        }
      `}</style>
    </div>
  )
}